import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {AdminService} from '../../../../services/admin.service';
import {ReviewSuggestionListsService} from './review-suggestion-lists.service';
import {ApiConnectService} from '../../../../services/api-connect.service';
import {UserService} from '../../../../services/user.service';
import { RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';

@Injectable()
export class SuggestionListsService {
  private listType: string;      // Для определения типа листа: свободный, продукт или стандарт. listType: free of standard;
  private standard: null;        // If listType === standard, use standardName in template field;
  private slDraft = null;

  public deputyPlanfixTasksGroupsService: any[] = [];
  public nobodyPlanfixTasksGroupsService: any[] = [];
  firstDisableService = false;

  private fArray: any = [];
  private faleOld: any = [];
  private fakeSLArray: any = [];

  public showSuccessMsgForReviewList = false;
  public showSuccessMsgOnSLList = false;

  // SL Data
  public templateService = '';              
  public descriptionService = '';           
  public photosService: File[] = [];        
  public photoUrlsService: string[] = [];    

  // Pagination parameter constants
  private readonly PAGE_PARAM = 'page';
  private readonly SIZE_PARAM = 'size';
  private readonly IS_ACTIVE_STATUS_PARAM = 'isActiveStatus';

  constructor(private http: HttpClient,
              private apiURL: ApiConnectService,
              private adminService: AdminService,
              private userService: UserService,
              public reviewSuggestionListsService: ReviewSuggestionListsService) {
  }

  getListType() {
    return this.listType;
  }


  getDeputyPlanfixTasksGroups() {
    return this.deputyPlanfixTasksGroupsService;
  }

  setDeputyPlanfixTasksGroups(dList) {
    this.deputyPlanfixTasksGroupsService = dList;
  }

  getNobodyPlanfixTasksGroups() {
    return this.nobodyPlanfixTasksGroupsService;
  }

  setNobodyPlanfixTasksGroups(dList) {
    this.nobodyPlanfixTasksGroupsService = dList;
  }


  // Use it for manage service state
  setListType(value: string) {
    this.listType = value;

    switch (this.listType) {
      case 'free':
        this.setDraft(null);
        this.setStandard(null);
        break;
      case 'standard':
        this.setDraft(null);
        break;
      case 'edit':
        this.setStandard(null);
        break;
      default:
        this.setDraft(null);
        this.setStandard(null);
        break;
    }
  }

  // STANDARDS
  hasStandard() {
    return this.standard !== null;
  }

  getStandard() {
    return this.standard;
  }

  setStandard(value) {
    this.standard = value;
  }

  // DRAFTS
  hasDraft() {
    return this.slDraft !== null;
  }

  getDraft() {
    return this.slDraft;
  }

  setDraft(draft) {
    this.slDraft = draft;
  }

  // Drafts
  addNewDraft(newDraft) {
    return this.http.post(this.apiURL.addNewDraft, newDraft, {observe: 'response'});
  }

  updateDraft(draft) {
    return this.http.patch(this.apiURL.updateDraft, draft, {observe: 'response'});
  }

  // Get my drafts list
  getDraftsByUserID(userID) {
    return this.http.get(this.apiURL.getDraftsByUserID + userID + '/drafts/', {observe: 'response'});
  }

  // Get one draft by draft ID
  getDraftByID(draftID) {
    // this.apiURL.getDraftByUserID
    return this.http.get('http://localhost:3000/drafts/' + draftID, {observe: 'response'});
  }

  // My Suggestions lists
  addNewSL(newSL) {
    if (this.hasDraft()) {
      return this.http.post(this.apiURL.addNewSLDeleteDraft + this.getDraft().id, newSL, {observe: 'response'});
    } else {
      return this.http.post(this.apiURL.addNewSL, newSL, {observe: 'response'});
    }
  }

  addNewMist(id, newSL) {
      return this.http.post(this.apiURL.addNewMist + id, newSL, {observe: 'response'});
  }

  cancelSuggesionFull(id, reason){
    const cancelSL = {
      reason: reason
    };
    return this.http.patch('/backend/common/suggestions/' + id + '/cancel_approval', cancelSL, {observe: 'response'});
  }

  restoreSuggesionFull(id, reason){
    const cancelSL = {
      reason: reason
    };
    return this.http.patch('/backend/common/suggestions/' + id + '/restore' + '?' + 'description=' + cancelSL.reason, {observe: 'response'});
  }

  getSLByUserID(userID) {
    return this.http.get(this.apiURL.getSLByUserID + userID, {observe: 'response'});
  }

  getSLByUserIDWithPagination(userID: string, page: number = 0, size: number = 10, isActiveStatus: boolean = true) {
    const params = new HttpParams()
      .set(this.PAGE_PARAM, page.toString())
      .set(this.SIZE_PARAM, size.toString())
      .set(this.IS_ACTIVE_STATUS_PARAM, isActiveStatus.toString());
    
    return this.http.get(this.apiURL.getSLByUserID + userID, { 
      params: params, 
      observe: 'response' 
    });
  }

  getSLByID(slID) {
    return this.http.get(this.apiURL.getSLByID + slID, {observe: 'response'});
  }

  getAllSLByUserID(groupID) {
    return this.http.get(this.apiURL.getAllSLForUser + groupID, {observe: 'response'});
  }

  getSLForReviewByHeadID(headID) {
    return this.http.get(this.apiURL.getAllSLForReviewForHead + headID, {observe: 'response'});
  }

  getSLForReviewByHeadIDWithPagination(headID: string, page: number = 0, size: number = 10) {
    const params = new HttpParams()
      .set(this.PAGE_PARAM, page.toString())
      .set(this.SIZE_PARAM, size.toString());
    
    return this.http.get(this.apiURL.getAllSLForReviewForHead + headID, { 
      params: params, 
      observe: 'response' 
    });
  }

  getAllSLByUserIDWithPagination(groupID: string, page: number = 0, size: number = 10) {
    const params = new HttpParams()
      .set(this.PAGE_PARAM, page.toString())
      .set(this.SIZE_PARAM, size.toString());
    
    return this.http.get(this.apiURL.getAllSLForUser + groupID, { 
      params: params, 
      observe: 'response' 
    });
  }

  patchWithId(path: string, params: HttpParams = new HttpParams(), body: Object = {}): Observable<any> {
    return this.http.patch(path, body, {
        params: params,
        responseType: 'json'
    });
}
  // Redirecting
  redirectSL(reason, targetDivisionID, currentSLID) {
    // reassign group
    return this.http.patch(this.apiURL.redirectSL + currentSLID + /reassign/ + targetDivisionID, new HttpParams().set('description', reason), {observe: 'response'});
  }

  // cancel
  cancelSL(reasonText, slID) {
    const cancelSL = {
      reason: reasonText
    };
    return this.http.patch(this.apiURL.cancelSL + slID + '/cancel', cancelSL, {observe: 'response'});
  }

  postponeSL(reasonText, dateTo, slID) {
    // postpone
    const postponeSL = {
      reason: reasonText,
      date: dateTo.year + '-' + dateTo.month + '-' + dateTo.day
    };

    return this.http.patch(this.apiURL.postponeSL + slID + '/postpone', postponeSL, {observe: 'response'});
  }

  updatePostponementSL(reasonText, dateTo, slID) {
    // updatePostpone
    const postponeSL = {
      reason: reasonText,
      date: dateTo.year + '-' + dateTo.month + '-' + dateTo.day,
      id: slID
    };

    return this.http.post(this.apiURL.postponeSL + 'postpone/update', postponeSL, {observe: 'response'});
  }

  cancelPostponementSL(slID) {
    return this.http.patch(this.apiURL.postponeSL + `postpone/cancellation/${slID}`, '', {observe: 'response'});
  }

  implementSL(reasonText, slID) {
    const implementSL = {
      result: reasonText
    };
    return this.http.patch(this.apiURL.implementSL + slID + '/implement', implementSL, {observe: 'response'});
  }

  sendToPlanfix(toSend) {
    return this.http.patch(this.apiURL.addTasksToPlanfix, toSend, {observe: 'response'});
  }

  addMessageToChat(message) {
    const msg = message;
    const sListID = this.reviewSuggestionListsService.getOpenedSLID();
    const reqHeaders = new HttpHeaders({'offset': this.userService.getTimezoneOffset()});
    return this.http.post(this.apiURL.addMessageToSLChat + sListID + '/message', msg, {observe: 'response', headers: reqHeaders});
  }

  getSLChatMessages() {
    const reqHeaders = new HttpHeaders({'offset': this.userService.getTimezoneOffset()});
    const slID = this.reviewSuggestionListsService.getOpenedSLID();
    return this.http.get(this.apiURL.getSLChatHistory + slID, {observe: 'response', headers: reqHeaders});
  }

  getSLPhotos(slID: string) {
    return this.http.get(this.apiURL.getSLPhotos + slID + '/photos', {observe: 'response'});
  }

  getPhotoById(photoId: string) {
    const params = new HttpParams().set('id', photoId);
    return this.http.get(this.apiURL.getSLPhotos + 'photos', {params, responseType: 'blob', observe: 'response'});
  }

  clearSLData() {
    this.templateService = '';               
    this.descriptionService = '';            
    this.photosService = [];                 
    this.photoUrlsService = [];
  }

  addPhoto(file: File): boolean {
    if (this.photosService.length >= 5 || file.size > 5 * 1024 * 1024) return false;
    
    this.photosService.push(file);
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.photoUrlsService.push(e.target.result);
    };
    reader.readAsDataURL(file);
    return true;
  }

  removePhoto(index: number) {
    this.photosService.splice(index, 1);
    this.photoUrlsService.splice(index, 1);
  }

  createFormDataWithPhotos(slData: any): FormData {
    const formData = new FormData();

    const dataBlob = new Blob([JSON.stringify(slData)], { type: 'application/json' });
   
    formData.append('data', dataBlob);
    
    this.photosService.forEach(photo => {
      formData.append('photos', photo, photo.name); 
    });
    
    return formData;
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/suggestion-lists/services/suggestion-lists.service.ts